import { isPortableTextTextBlock, isPortableTextSpan } from "@sanity/types";
function getTextBlockText(block) {
  return block.children.map((child) => child.text ?? "").join("");
}
function isEmptyTextBlock(block) {
  if (!isPortableTextTextBlock(block))
    return !1;
  const onlyText = block.children.every(isPortableTextSpan), blockText = getTextBlockText(block);
  return onlyText && blockText === "";
}
export {
  getTextBlockText,
  isEmptyTextBlock
};
//# sourceMappingURL=util.is-empty-text-block.js.map
